// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"733c7d0b","917":"f9b24a2f"}[chunkId] + ".chunk.js";
};